import { useMemo } from 'react';
import { useSearchParams } from 'react-router';
import { useStableParams } from '../../../../../routes/useStableParams';

export interface PickingPositionParams {
  calculationId: number;
  sourceSkuId: number;
  targetSkuId: number;
}

export const usePickingPositionParamsFromUrl = (): PickingPositionParams | undefined => {
  const { calculationId } = useStableParams();
  const [searchParams] = useSearchParams();

  const pairingCodeFromUrl = searchParams.get('p');

  return useMemo(() => {
    const calculationIdNumber = calculationId ? Number(calculationId) : undefined;
    const [sourceSkuId, targetSkuId] = pairingCodeFromUrl?.split('-').map(Number) ?? [
      undefined,
      undefined,
    ];

    if (!calculationIdNumber || !sourceSkuId || !targetSkuId) {
      return undefined;
    }

    return {
      calculationId: calculationIdNumber,
      sourceSkuId,
      targetSkuId,
    };
  }, [calculationId, pairingCodeFromUrl]);
};
